<div *ngIf="infoLinks">
  <table>
    <tr *ngFor="let link of infoLinks">
      <td>
        <a href="{{ link.href }}" target="_blank">{{ link.name }}</a>
      </td>
    </tr>
  </table>
</div>
